module.exports = __webpack_public_path__ + "static/simufact02-0e99eaa44b884cae6b61a6407ce9fb52.png";